import React from "react"
import classNames from "classnames"
import formatCurrencyString from "../../utils/formatCurrencyString"

interface IPriceProps {
  price?: string | number
  compareAtPrice?: string | number
  className?: string
  variant?: "default" | "promo"
}

const Price = ({
  price,
  compareAtPrice,
  className,
  variant = "default",
}: IPriceProps) => {
  return (
    <div className={classNames("flex flex-wrap items-center", className)}>
      {price && (
        <h5
          className={classNames(
            "text-h5",
            compareAtPrice && "mr-[11px] text-[#E80606]",
            variant === "promo" && "text-[#FFF]"
          )}
        >
          {formatCurrencyString({ amount: price })}
        </h5>
      )}

      {compareAtPrice && (
        <>
          <div
            className={classNames(
              "h-[20px] w-[2px]",
              "bg-darkGrey",
              variant === "promo" && "bg-[#FFF]"
            )}
          />
          <h5
            className={classNames(
              "ml-[11px] text-crossedPriceRegular font-normal text-mediumGrey line-through",
              variant === "promo" && "text-[#FFF]"
            )}
          >
            {formatCurrencyString({ amount: compareAtPrice })}
          </h5>
        </>
      )}
    </div>
  )
}

export default Price
